var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper-login"},[_c('span',{domProps:{"textContent":_vm._s(_vm.$t('ct-comment-theme-title'))}}),_c('div',[_c('a',{attrs:{"href":`/blog-login?post=${_vm.url}`},domProps:{"textContent":_vm._s(_vm.$t('ct-sign-up'))}}),_c('a',{attrs:{"href":`/blog-login?post=${_vm.url}`},domProps:{"textContent":_vm._s(_vm.$t('ct-sign-in'))}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }